import {createReducer, on} from "@ngrx/store";
import * as PlanetListActions from './planet-list.actions';
import {Planet} from "../../models/Planet";
export const planetFeatureKey = 'planets';
export const PlanetListInitialState: Planet[] = [];
export const PlanetListReducer = createReducer<Planet[]>(PlanetListInitialState,
  on(PlanetListActions.update, (_state, { planets }) => planets),
);
